import Vue from "vue";
import Vuex from "vuex";
import snackbar from "@/store/modules/snackbar";
import loading from "@/store/modules/loading";
import agricultor from "@/store/modules/agricultor";
import session from "@/store/modules/session";
import maquinas from "@/store/modules/maquinas";
import personal from "@/store/modules/personal";
import zonas from "@/store/modules/zonas";
import temporada from "@/store/modules/temporada";
import fichas from "@/store/modules/fichas";
import productos from "@/store/modules/productos";
import rubros from "@/store/modules/rubros";
import trabajos from "@/store/modules/trabajos";
import rendimientoCosecha from "@/store/modules/rendimientoCosecha";
import precipitacion from "@/store/modules/precipitacion";
import resumen from "@/store/modules/resumen";
import alquiler from "@/store/modules/alquiler";
import admin from "@/store/modules/admin";
import grupoExplotacion from "@/store/modules/grupoExplotacion";
import variedades from "@/store/modules/variedades";
import cultivos from "@/store/modules/cultivos";
import establecimientos from "@/store/modules/establecimientos";
import retiros from "@/store/modules/retiros";
import conceptos from "@/store/modules/conceptos";
import movimientos from "@/store/modules/movimientos";
import lotes from "@/store/modules/lotes";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    snackbar,
    loading,
    agricultor,
    session,
    maquinas,
    personal,
    zonas,
    temporada,
    fichas,
    productos,
    rubros,
    trabajos,
    rendimientoCosecha,
    precipitacion,
    resumen,
    alquiler,
    admin,
    grupoExplotacion,
    cultivos,
    variedades,
    establecimientos,
    retiros,
    conceptos,
    movimientos,
    lotes,
  },
  strict: debug,
});
